import * as z from "zod";

import { PaymentMethod } from "@modules/checkout/enums/payment-method";
import { PaymentStatus } from "@modules/checkout/enums/payment-status";

import { PaymentStatusSchema } from "./payment-status.schema";

export const CreditCardPaymentAttemptSchema = z
  .object({
    ExtraData: z.object({ FraudAnalysisReview: z.literal(true) }).nullable(),
    Status: PaymentStatusSchema.nullable().optional().default(null),
    Method: z.literal(PaymentMethod.CreditCard),
  })
  .transform((payload) => {
    if (payload.Status === PaymentStatus.Created || payload.Status === PaymentStatus.Failed) {
      return { ...payload, ExtraData: null };
    }
    return payload;
  });
